// frontend/src/data/coralCategories.ts
/**
 * Coral category and subcategory hierarchy.
 * Source: Tidal Gardens taxonomy (tidalgarden.com)
 *
 * Structure: { category: subcategory[] }
 * Used by AddLivestockModal and EditLivestockModal for guided coral classification.
 */

export const CORAL_CATEGORIES: Record<string, string[]> = {
  SPS: [
    'Acropora',
    'Anacropora',
    'Cyphastrea',
    'Hydnophora',
    'Leptoseris',
    'Montipora',
    'Pavona',
    'Pocillopora',
    'Porites',
    'Psammopora',
    'Seriatopora',
    'Stylocoeniella',
    'Stylophora',
    'Other SPS',
  ],
  LPS: [
    'Acanthastrea',
    'Acanthos',
    'Alveopora',
    'Blastomussa',
    'Bubble Corals',
    'Candy Cane',
    'Chalices',
    'Cynarina',
    'Duncans',
    'Elegance',
    'Favia/Favites',
    'Frogspawn',
    'Fungia',
    'Galaxea',
    'Goniopora',
    'Hammers',
    'Leptastrea',
    'Lobo Brains',
    'Maze Brains',
    'Pectinia',
    'Platygyra',
    'Scolymia',
    'Scroll Corals',
    'Sun Corals',
    'Torches',
    'Other LPS',
  ],
  'Zoanthids/Palythoa': [
    'Zoanthus',
    'Palythoas',
    'Parazoas',
  ],
  Mushrooms: [
    'Discosoma',
    'Rhodactis',
    'Ricordea',
    'Pseudo',
  ],
  'Soft Corals': [
    'Anthelia',
    'Blue Ridge',
    'Clove Polyps',
    'Gorgonians',
    'Kenya Trees',
    'Lobophytum',
    'Nephthea',
    'Pipe Organs',
    'Sinularia',
    'Star Polyps',
    'Toadstools',
    'Xenia',
    'Other Soft',
  ],
  Anemones: [
    'Bubble Tip',
    'Flower',
    'Carpet',
  ],
};

/** Mantine Select options for the top-level coral categories. */
export const CORAL_CATEGORY_OPTIONS = Object.keys(CORAL_CATEGORIES).map(
  (cat) => ({ value: cat, label: cat }),
);

/** Get subcategory options for a given category (for Mantine Select). */
export function getSubcategoriesForCategory(
  category: string,
): { value: string; label: string }[] {
  const subs = CORAL_CATEGORIES[category];
  if (!subs) return [];
  return subs.map((s) => ({ value: s, label: s }));
}
